import { render, staticRenderFns } from "./ShopSwitcher.vue?vue&type=template&id=73657c6a&"
import script from "./ShopSwitcher.vue?vue&type=script&lang=js&"
export * from "./ShopSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports